import { onboarding } from '@services';

interface IRequest {
  studioId: string;
  fileId?: string;
  assetId: string;
}

interface ICheckAndCreateThread {
  threadId: string;
  exists: boolean;
}

const checkAndCreateThread = async ({
  studioId,
  assetId,
  fileId,
}: IRequest): Promise<ICheckAndCreateThread> => {
  const { data } = await onboarding.post<ICheckAndCreateThread>(
    `/api/v1/chat`,
    {
      studioId,
      assetId,
      fileId,
    },
  );

  return data;
};

export { checkAndCreateThread };
